import React from 'react';

interface BCPPageTitleProps {
  title: string;
  isEditMode?: boolean;
  editInfo?: {
    title: string;
    id: string;
  };
}

const BCPPageTitle: React.FC<BCPPageTitleProps> = ({
  title,
  isEditMode = false,
  editInfo,
}) => {
  return (
    <div className="text-center mb-8 w-full">
      <h2
        className="text-2xl font-semibold"
        style={{
          color: '#0D357F',
        }}
      >
        {title}
      </h2>
      {isEditMode && editInfo && (
        <p className="text-sm text-gray-600 mt-2">
          {editInfo.title} (ID: {editInfo.id})
        </p>
      )}
    </div>
  );
};

export default BCPPageTitle;
